import AbstractColumn from './AbstractColumn'

export default class FileColumn extends AbstractColumn {
  constructor (field) {
    super()
    this.init(field)
    this.type = 'input'
    this.htmlType = 'file'
    this.maxsize = 20
    this.multiFile = false
    this.action = process.env.VUE_APP_API_BASE_URL + '/upload/'
    this.info = 'Max ' + this.maxsize + ' MB'
    this.limit = 1
    this.buttonText = 'Upload'
    this.autoUpload = false
    this.fileInfoColumn = 'file_info'
    this.fileNameColumn = 'nomefile'
    this.userUpload = 'username'
    this.files = []
    this.data = { id: null }
    this.hasFileToUpload = false
  }

  withHasFileToUpload (hasFileToUpload) {
    this.hasFileToUpload = hasFileToUpload
    return this
  }

  withData (data) {
    this.data = data
    return this
  }

  withUsername (userUpload) {
    this.userUpload = userUpload
    return this
  }

  withFileNameColumn (fileNameColumn) {
    this.fileNameColumn = fileNameColumn
    return this
  }

  withFiles (files) {
    this.files = files
    return this
  }

  withFileColumn (fileInfoColumn) {
    this.fileInfoColumn = fileInfoColumn
    return this
  }

  withAutoUpload (autoUpload) {
    this.autoUpload = autoUpload
    return this
  }

  withButtonText (buttonText) {
    this.buttonText = buttonText
    return this
  }

  withLimit (limit) {
    this.limit = limit
    return this
  }

  withInfo (info) {
    this.info = info
    return this
  }

  withAction (action) {
    this.action = action
    return this
  }

  withMaxSize (maxsize) {
    this.maxsize = maxsize
    return this
  }

  withMultiFile (multiFile) {
    this.multiFile = multiFile
    return this
  }
}
